import React, { useState, useEffect } from "react";

const Grocerytickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTickets = async () => {
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken");

      if (!vendorId || !token) {
        setError("Missing vendorId or token");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://backend.maamaas.com/food/vendor-tickets/vendor/${vendorId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch tickets");
        }

        const result = await response.json();

        const transformed = result.map((ticket, index) => ({
          sno: index + 1,
          ticketType: ticket.ticketType,
          message: ticket.message,
          status: ticket.status,
          adminResponse: ticket.adminResponse || "—",
          createdAt: new Date(ticket.createdAt).toLocaleString(),
          resolvedAt: ticket.resolvedAt
            ? new Date(ticket.resolvedAt).toLocaleString()
            : "—",
        }));

        setTickets(transformed);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {/* <h2 style={{ marginBottom: "10px" }}>🎫 Vendor Tickets</h2> */}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2" }}>
            {[
              "S.No",
              "Ticket Type",
              "Message",


              "Created At",
              "Resolved At",
              "Super Admin Response",
              "Status",
            ].map((head) => (
              <th key={head} style={thStyle}>
                {head}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tickets.map((item, index) => (
            <tr
              key={index}
              style={index % 2 === 0 ? evenRowStyle : oddRowStyle}
            >
              <td style={tdStyle}>{item.sno}</td>
              <td style={tdStyle}>{item.ticketType}</td>
              <td style={tdStyle}>{item.message}</td>


              <td style={tdStyle}>{item.createdAt}</td>
              <td style={tdStyle}>{item.resolvedAt}</td>
              <td style={tdStyle}>{item.adminResponse}</td>
              <td style={tdStyle}>
                <span
                  style={{
                    color: item.status === "RESOLVED" ? "green" : "orange",
                    fontWeight: "bold",
                  }}
                >
                  {item.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

/* Styles */
const thStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#b15cd6",
  color: "white",
  padding: "6px",
};

const tdStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  padding: "6px",
};

const evenRowStyle = { backgroundColor: "#f9f9f9" };
const oddRowStyle = { backgroundColor: "#fff" };

export default Grocerytickets;
